export default "__VITE_ASSET__CSBEumhB__"